import React from "react";
import { Form } from "react-bootstrap";

import ListSelector from "../atoms/ListSelector";

const items = [
  { value: "AB", desc: "Alberta" },
  { value: "BC", desc: "British Columbia" },
  { value: "MB", desc: "Manitoba" },
  { value: "NL", desc: "Newfoundland" },
  { value: "NT", desc: "Northwest Territories" },
  { value: "NS", desc: "Nova Scotia" },
  { value: "NU", desc: "Nunavit" },
  { value: "ON", desc: "Ontario" },
  { value: "PE", desc: "Prince Edward Island" },
  { value: "QC", desc: "Quebec" },
  { value: "SK", desc: "Saskatoon" },
  { value: "YT", desc: "Yukon" },
];



function ProvinceControl(props) {
  const as_comp = props.as === undefined ? null : props.as === null ? null : props.as;

  return (
    <React.Fragment>
    {as_comp !== null &&
    <Form.Group className="mb-3" as={as_comp}>
      <Form.Label>{props.label}</Form.Label>
      <ListSelector items={items} value={props.value} onChange={props.onChange} />
    </Form.Group>
    }

    {as_comp === null &&
    <Form.Group className="mb-3">
      <Form.Label>{props.label}</Form.Label>
      <ListSelector items={items} value={props.value} onChange={props.onChange} />
    </Form.Group>
    }
      
  </React.Fragment>
  );
}


export default ProvinceControl;
